import { useEffect, useRef } from "react";
import ErrorBoundary from "@common/ErrorBoundary/ErrorBoundary";
import { HtmlEmbedNode } from "@typings/richText";
import * as Styled from "./HtmlEmbed.styled";

const HtmlEmbed: React.FC<HtmlEmbedNode["data"]> = ({ html }) => {
  const shadowRootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (shadowRootRef.current) {
      const shadowRoot = shadowRootRef.current.shadowRoot || shadowRootRef.current.attachShadow({ mode: "open" });
      shadowRoot.innerHTML = html;
    }
  }, [html]);

  return <Styled.ShadowDomContainer ref={shadowRootRef} />;
};

const SafeHtmlEmbed: React.FC<HtmlEmbedNode["data"]> = (props) => (
  <ErrorBoundary onError={() => <></>}>
    <HtmlEmbed {...props} />
  </ErrorBoundary>
);

export default SafeHtmlEmbed;
